(() => {
  const shirtPaths = {
    '/products/classic-boxy-tee-230-gsm': 'BLACK / CHARCOAL',
    '/products/classic-boxy-tee-230-gsm-1': 'WHITE'
  };

  function currentPath() {
    return window.location.pathname.replace(/\/$/, '');
  }

  function simplifyFixedColor() {
    const fixedColor = shirtPaths[currentPath()];
    if (!fixedColor) return;
    const info = document.querySelector('.product__info-container');
    if (!info || info.querySelector('.cb-fixed-color')) return;

    const optionGroups = Array.from(info.querySelectorAll('.product-form__input'));
    const colorGroup = optionGroups.find((group) => {
      const label = group.querySelector('.form__label, label');
      return label && label.textContent.trim().toLowerCase() === 'color';
    });
    if (!colorGroup) return;

    colorGroup.hidden = true;
    colorGroup.setAttribute('aria-hidden', 'true');
    const metadata = document.createElement('p');
    metadata.className = 'cb-fixed-color';
    metadata.innerHTML = `<span>COLOR</span><strong>${fixedColor}</strong>`;
    colorGroup.insertAdjacentElement('afterend', metadata);
  }

  function cleanShirtDescription() {
    if (!shirtPaths[currentPath()]) return;
    const description = document.querySelector('.product__description');
    if (!description || description.dataset.cbCleaned === 'true') return;
    description.dataset.cbCleaned = 'true';

    const existingTable = description.querySelector('table');
    const details = document.createElement('div');
    details.className = 'cb-product-details';
    details.innerHTML = `
      <section class="cb-detail-section" aria-labelledby="cb-product-details-heading">
        <h2 id="cb-product-details-heading">PRODUCT</h2>
        <ul class="cb-detail-list">
          <li>ITEM RU0034</li><li>230 GSM</li><li>100% COTTON</li><li>LOOSE / BOXY FIT</li>
          <li>DROP SHOULDER</li><li>SHORT SLEEVE</li><li>ROUND / O-NECK</li><li>PRINT AREA 40 × 52 CM</li>
        </ul>
      </section>
      <section class="cb-detail-section" aria-labelledby="cb-care-heading">
        <h2 id="cb-care-heading">CARE</h2>
        <ul class="cb-detail-list">
          <li>MACHINE WASH 30°C / GENTLE</li><li>DO NOT BLEACH</li><li>TUMBLE DRY LOW</li>
          <li>IRON LOW / DO NOT IRON PRINT</li><li>DO NOT DRY CLEAN</li>
        </ul>
      </section>`;

    if (existingTable) {
      const sizeSection = document.createElement('section');
      sizeSection.className = 'cb-detail-section';
      sizeSection.setAttribute('aria-labelledby', 'cb-size-heading');
      sizeSection.innerHTML = '<h2 id="cb-size-heading">SIZE</h2><div class="cb-size-chart-wrap"></div>';
      sizeSection.querySelector('.cb-size-chart-wrap').append(existingTable.cloneNode(true));
      details.append(sizeSection);
    }

    description.replaceChildren(details);
  }

  function dedupeCollectionCards() {
    document.querySelectorAll('.card-wrapper').forEach((card) => {
      if (card.dataset.cbDedupe === 'true') return;
      const headings = card.querySelectorAll('.card__heading');
      if (headings.length < 2) return;
      const firstHeading = headings[0];
      const productLink = firstHeading.querySelector('a');
      const inner = card.querySelector('.card__inner');
      if (productLink && inner && !inner.querySelector('.cb-card-hit')) {
        const hit = document.createElement('a');
        hit.className = 'cb-card-hit';
        hit.href = productLink.href;
        hit.setAttribute('aria-label', `View ${headings[1].textContent.trim()}`);
        inner.append(hit);
      }
      firstHeading.remove();
      card.dataset.cbDedupe = 'true';
    });
  }

  function tuneCart() {
    if (currentPath() !== '/cart') return;
    const continueLink = document.querySelector('.cart__warnings a.button');
    if (continueLink) {
      continueLink.href = '/collections/current-drop';
      continueLink.textContent = 'SHOP CURRENT DROP';
    }
    const filledCartLink = document.querySelector('.title-wrapper-with-link a');
    if (filledCartLink) {
      filledCartLink.href = '/collections/current-drop';
      filledCartLink.textContent = 'CONTINUE SHOPPING';
    }
  }

  function removeHiddenProductsFromSearch() {
    if (currentPath() !== '/search') return;
    document.querySelectorAll('a[href*="/products/basic-tote-bag"]').forEach((link) => {
      const result = link.closest('.grid__item, li');
      if (result) result.remove();
    });

    const remaining = document.querySelectorAll('.template-search__results .grid__item').length;
    document.querySelectorAll('[role="status"], .template-search__results-count').forEach((status) => {
      const text = status.textContent.trim();
      if (!/^\d+\s+results?\s+found/i.test(text)) return;
      status.textContent = text.replace(/^\d+\s+results?\s+found/i, `${remaining} ${remaining === 1 ? 'result' : 'results'} found`);
    });
  }

  function formatProductDescription(description) {
    if (!description || description.dataset.cbFormatted === 'true') return;
    description.dataset.cbFormatted = 'true';

    Array.from(description.children).forEach((row) => {
      if (row.tagName !== 'DIV' || row.querySelector('table')) return;
      const text = row.textContent.trim();
      const splitAt = text.indexOf(':');
      if (splitAt < 1) return;
      const label = text.slice(0, splitAt).trim();
      const value = text.slice(splitAt + 1).trim();
      row.classList.add('cb-spec-row');
      row.textContent = '';
      const labelNode = document.createElement('span');
      const valueNode = document.createElement('span');
      labelNode.className = 'cb-spec-label';
      valueNode.className = 'cb-spec-value';
      labelNode.textContent = label;
      valueNode.textContent = value;
      row.append(labelNode, valueNode);
    });
  }

  function tuneIkigaiProduct() {
    if (!location.pathname.includes('/products/ikigai-physical-exclusive-edition-pre-order')) return;
    const info = document.querySelector('.product__info-container');
    if (!info) return;

    if (!info.querySelector('.cb-native-preorder')) {
      const notice = document.createElement('p');
      notice.className = 'cb-native-preorder';
      notice.textContent = 'LIMITED PRE-ORDER / MANUFACTURED AFTER THE ORDER WINDOW CLOSES';
      const form = info.querySelector('product-form, .product-form');
      if (form) form.insertAdjacentElement('beforebegin', notice);
      else info.append(notice);
    }

    const submitLabel = info.querySelector('.product-form__submit span');
    if (submitLabel && !submitLabel.textContent.toLowerCase().includes('sold out')) {
      submitLabel.textContent = 'PRE-ORDER — $25';
    }
  }

  function runPolish() {
    document.querySelectorAll('.product__description').forEach(formatProductDescription);
    simplifyFixedColor();
    cleanShirtDescription();
    dedupeCollectionCards();
    tuneCart();
    removeHiddenProductsFromSearch();
    tuneIkigaiProduct();
  }

  runPolish();
  document.addEventListener('shopify:section:load', () => {
    runPolish();
  });
})();
